export enum PortalPageType {
    Public
}